export default [
  {
    title: 'Dashboard',
    route: 'v1_admin_dashboard',
    icon: 'none',
  },
  {
    title: 'Users',
    route: 'v1_userss',
    icon: 'none',
  },
]
